// extracted by mini-css-extract-plugin
export default {"column-select-drag-drop":"GQBT6"};